import React from 'react';
import { motion } from 'framer-motion';
import './NousContacter.css';
import { LuPhone, LuMail, LuClock, LuShieldCheck, LuGlobe } from 'react-icons/lu';

const CONTACT_ITEMS = [
  {
    icon: <LuPhone strokeWidth="1.4px" />,
    label: 'Téléphone',
    value: '+33 7 56 85 25 52',
    href: 'tel:+33756852552',
    description: 'Appelez-nous directement, 7j/7',
  },
  {
    icon: <LuMail strokeWidth="1.4px" />,
    label: 'Email',
    value: 'hello@air-transport-animalier.com',
    href: 'mailto:hello@air-transport-animalier.com',
    description: 'Réponse garantie sous 24h ouvrées',
  },
  {
    icon: <LuMail strokeWidth="1.4px" />,
    label: 'Email2',
    value: 'transportdesanimaux@air-transport-animalier.com',
    href: 'mailto:transportdesanimaux@air-transport-animalier.com',
    description: 'Réponse garantie sous 24h ouvrées',
  },
];

const REASSURANCES = [
  {
    icon: <LuClock strokeWidth="1.4px" />,
    title: 'Disponibles 24h/24',
    desc: 'Notre équipe est joignable à tout moment, même les week-ends et jours fériés.',
  },
  {
    icon: <LuShieldCheck strokeWidth="1.4px" />,
    title: 'Service sécurisé',
    desc: 'Vos données et celles de votre animal sont traitées avec la plus grande confidentialité.',
  },
  {
    icon: <LuGlobe strokeWidth="1.4px" />,
    title: '5 pays desservis',
    desc: 'Nous accompagnons vos compagnons à travers le monde entier, sans exception.',
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.13 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } },
};

export default function NousContacter() {
  return (
    <section className="nous-contacter" id="nous-contacter">
      {/* Décors de fond */}
      <div className="nc-orb nc-orb--1" />
      <div className="nc-orb nc-orb--2" />
      <div className="nc-grain" />

      <div className="nc-container">

        {/* ── En-tête ── */}
        <motion.div
          className="nc-header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="section-label">Contact</span>
          <h1 className="section-title nc-title">Nous contacter</h1>
          <p className="nc-intro">
            Notre équipe est à votre disposition <strong>24h/24 et 7j/7</strong> pour répondre
            à toutes vos demandes concernant le transport, le suivi et l'accompagnement de vos
            animaux. Nous mettons un point d'honneur à vous offrir un service rapide,
            professionnel et sécurisé afin de garantir le bien-être de votre compagnon tout
            au long de son voyage.
          </p>
        </motion.div>

        {/* ── Zone centrale : carte de contact + réassurance ── */}
        <div className="nc-body">

          {/* Carte contact principale */}
          <motion.div
            className="nc-card-contact"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="nc-card-header">
              <span className="nc-card-eyebrow">Nos coordonnées</span>
              <p className="nc-card-sub">
                Nous restons disponibles à tout moment pour vous informer,
                vous accompagner et répondre à vos questions.
              </p>
            </div>

            <div className="nc-channels">
              {CONTACT_ITEMS.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="nc-channel"
                  aria-label={item.label}
                >
                  <div className="nc-channel-icon">{item.icon}</div>
                  <div className="nc-channel-content">
                    <span className="nc-channel-label">{item.label}</span>
                    <span className="nc-channel-value">{item.value}</span>
                    <span className="nc-channel-desc">{item.description}</span>
                  </div>
                  <span className="nc-channel-arrow">→</span>
                </a>
              ))}
            </div>

            {/* Badge disponibilité */}
            <div className="nc-availability">
              <span className="nc-availability-dot" />
              <span>Équipe disponible — réponse rapide assurée</span>
            </div>
          </motion.div>

          {/* Bloc réassurance */}
          <motion.div
            className="nc-reassurances"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-60px' }}
          >
            {REASSURANCES.map((item) => (
              <motion.div
                key={item.title}
                className="nc-reassurance-card"
                variants={itemVariants}
                whileHover={{ y: -5, transition: { duration: 0.25 } }}
              >
                <div className="nc-reassurance-icon">{item.icon}</div>
                <div>
                  <h3 className="nc-reassurance-title">{item.title}</h3>
                  <p className="nc-reassurance-desc">{item.desc}</p>
                </div>
              </motion.div>
            ))}

            {/* Encart accent */}
            <motion.div className="nc-accent-card" variants={itemVariants}>
              <p className="nc-accent-text">
                "Votre compagnon mérite le meilleur — et nous sommes là pour le lui offrir,
                à chaque étape du voyage."
              </p>
              <span className="nc-accent-sig">— L'équipe Air transport animal</span>
            </motion.div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}